import { Component } from '@angular/core';

@Component({
    selector: 'nh-helpGlossary',
    templateUrl: './memberLoginHelpGlossery.component.html',
    styleUrls: ['./memberLoginHelpGlossery.component.scss'],
    standalone: false
})
export class MemberLoginHelpGlossaryComponent {
  constructor() {}
panelOpen = false;
coverageOpen = false;
submissionStatusOpen = false;
applicationFlowOpen = false;
healthPlanDetailsOpen = false;
houseHoldOpen = false;
accountManagement = false;

togglePanel(from){
  if(from === "help"){
  this.panelOpen = !this.panelOpen
  this.coverageOpen = false;
  this.submissionStatusOpen = false;
  this.applicationFlowOpen = false;
  this.healthPlanDetailsOpen = false;
  this.houseHoldOpen = false;
  this.accountManagement = false;
  } else if(from === "coverage"){
  this.coverageOpen = !this.coverageOpen;
  this.submissionStatusOpen = false;
  this.applicationFlowOpen = false;
  this.healthPlanDetailsOpen = false;
  this.houseHoldOpen = false;
  this.accountManagement = false;
  } else if(from === "submission"){
  this.submissionStatusOpen = !this.submissionStatusOpen
  this.coverageOpen = false;
  this.applicationFlowOpen = false;
  this.healthPlanDetailsOpen = false;
  this.houseHoldOpen = false;
  this.accountManagement = false;
  } else if(from === "application"){
  this.applicationFlowOpen = !this.applicationFlowOpen
  this.coverageOpen = false;
  this.submissionStatusOpen = false;
  this.healthPlanDetailsOpen = false;
  this.houseHoldOpen = false;
  this.accountManagement = false;
  } else if(from === "healthPlan"){
  this.healthPlanDetailsOpen = !this.healthPlanDetailsOpen
  this.coverageOpen = false;
  this.submissionStatusOpen = false;
  this.applicationFlowOpen = false;
  this.houseHoldOpen = false;
  this.accountManagement = false;
  } else if(from === "household"){
  this.houseHoldOpen  = !this.houseHoldOpen
  this.healthPlanDetailsOpen = false;
  this.coverageOpen = false;
  this.submissionStatusOpen = false;
  this.applicationFlowOpen = false;
  this.accountManagement = false;
  } else if(from === "manageAccount"){
  this.accountManagement = !this.accountManagement;
  this.houseHoldOpen  = false;
  this.healthPlanDetailsOpen = false;
  this.coverageOpen = false;
  this.submissionStatusOpen = false;
  this.applicationFlowOpen = false;
  }

}


}
